export interface SideBar {
  text: string
  textPosition: string
  imgCode: string
  id: string
  imgTxtOnly: boolean
  fontAwesome: boolean
  listType: string
  groupList?: boolean
  subMenu: SubMenu[]
  splitCategory?: SideBar[] 
}

export interface SubMenu {
  text: string
  sideCode: string
  mainImg: string
  fontAwesome: boolean
  webCode?: string
  childSubMenu?: ChildSubMenu[]
}

export interface ChildSubMenu {
  text: string
  sideImg: string
  mainImg: string
  webCode: string
}
const data: SideBar[] = [
  {
    "text": "Cabinet Fronts",
    "textPosition": "side-menu",
    "imgCode": "Main_Icons/Both_Cabinet_Fronts",
    "id": "block-2",
    "imgTxtOnly": false,
    "fontAwesome": false,
    "listType": "medium",
    "groupList": false,
    "subMenu": [],
    "splitCategory": [
      {
        "text": "Base Cabinet Fronts",
        "textPosition": "menu",
        "imgCode": "Main_Icons/Base_Cabinet_Fronts",
        "id": "block-1",
        "imgTxtOnly": true,
        "fontAwesome": false,
        "listType": "medium",
        "subMenu": [
          {
            "text": "Colour Collection - Deluxe Supermatt",
            "sideCode": "",
            "mainImg": "",
            "fontAwesome": false,
            "childSubMenu": [
              {
                "text": "Lotus White",
                "sideImg": "Swatches/Unity-Fronts/Colour-Collection/Deluxe-Supermatt/Swatch-Base-Cabs-Deluxe-Supermatt-Lotus_White.jpg",
                "mainImg": "Unity/Unity-Fronts/Colour-Collection/Deluxe-Supermatt/Base-Cabs-Deluxe-Supermatt-Lotus_White.png",
                "webCode": "bc1"
              },
              {
                "text": "Salt Grey",
                "sideImg": "Swatches/Unity-Fronts/Colour-Collection/Deluxe-Supermatt/Swatch-Base-Cabs-Deluxe-Supermatt-Salt_Grey.jpg",
                "mainImg": "Unity/Unity-Fronts/Colour-Collection/Deluxe-Supermatt/Base-Cabs-Deluxe-Supermatt-Salt_Grey.png",
                "webCode": "bc2"
              },
              {
                "text": "Sandstone",
                "sideImg": "Swatches/Unity-Fronts/Colour-Collection/Deluxe-Supermatt/Swatch-Base-Cabs-Deluxe-Supermatt-Sandstone.jpg",
                "mainImg": "Unity/Unity-Fronts/Colour-Collection/Deluxe-Supermatt/Base-Cabs-Deluxe-Supermatt-Sandstone.png",
                "webCode": "bc3"
              },
              {
                "text": "Moss",
                "sideImg": "Swatches/Unity-Fronts/Colour-Collection/Deluxe-Supermatt/Swatch-Base-Cabs-Deluxe-Supermatt-Moss.jpg",
                "mainImg": "Unity/Unity-Fronts/Colour-Collection/Deluxe-Supermatt/Base-Cabs-Deluxe-Supermatt-Moss.png",
                "webCode": "bc4"
              },
              {
                "text": "Flint",
                "sideImg": "Swatches/Unity-Fronts/Colour-Collection/Deluxe-Supermatt/Swatch-Base-Cabs-Deluxe-Supermatt-Flint.jpg",
                "mainImg": "Unity/Unity-Fronts/Colour-Collection/Deluxe-Supermatt/Base-Cabs-Deluxe-Supermatt-Flint.png",
                "webCode": "bc5"
              },
              {
                "text": "Oxford Blue",
                "sideImg": "Swatches/Unity-Fronts/Colour-Collection/Deluxe-Supermatt/Swatch-Base-Cabs-Deluxe-Supermatt-Oxford_Blue.jpg",
                "mainImg": "Unity/Unity-Fronts/Colour-Collection/Deluxe-Supermatt/Base-Cabs-Deluxe-Supermatt-Oxford_Blue.png",
                "webCode": "bc6"
              },
              {
                "text": "Onyx Nero",
                "sideImg": "Swatches/Unity-Fronts/Colour-Collection/Deluxe-Supermatt/Swatch-Base-Cabs-Deluxe-Supermatt-Onyx_Nero.jpg",
                "mainImg": "Unity/Unity-Fronts/Colour-Collection/Deluxe-Supermatt/Base-Cabs-Deluxe-Supermatt-Onyx_Nero.png",
                "webCode": "bc7"
              },
              {
                "text": "Bordeaux",
                "sideImg": "Swatches/Unity-Fronts/Colour-Collection/Deluxe-Supermatt/Swatch-Base-Cabs-Deluxe-Supermatt-Bordeaux.jpg",
                "mainImg": "Unity/Unity-Fronts/Colour-Collection/Deluxe-Supermatt/Base-Cabs-Deluxe-Supermatt-Bordeaux.png",
                "webCode": "bc8"
              },
            ]
          },
          {
            "text": "Colour Collection - Supermatt",
            "sideCode": "",
            "mainImg": "",
            "fontAwesome": false,
            "childSubMenu": [
              {
                "text": "Pure White",
                "sideImg": "Swatches/Unity-Fronts/Colour-Collection/Supermatt/Swatch-Base-Cabs-Supermatt-Pure_White.jpg",
                "mainImg": "Unity/Unity-Fronts/Colour-Collection/Supermatt/Base-Cabs-Supermatt-Pure_White.png",
                "webCode": "bc9"
              },
              {
                "text": "Light Grey",
                "sideImg": "Swatches/Unity-Fronts/Colour-Collection/Supermatt/Swatch-Base-Cabs-Supermatt-Light_Grey.jpg",
                "mainImg": "Unity/Unity-Fronts/Colour-Collection/Supermatt/Base-Cabs-Supermatt-Light_Grey.png",
                "webCode": "bc10"
              },
              {
                "text": "Taupe Grey",
                "sideImg": "Swatches/Unity-Fronts/Colour-Collection/Supermatt/Swatch-Base-Cabs-Supermatt-Taupe_Grey.jpg",
                "mainImg": "Unity/Unity-Fronts/Colour-Collection/Supermatt/Base-Cabs-Supermatt-Taupe_Grey.png",
                "webCode": "bc11"
              },
              {
                "text": "Cashmere",
                "sideImg": "Swatches/Unity-Fronts/Colour-Collection/Supermatt/Swatch-Base-Cabs-Supermatt-Cashmere.jpg",
                "mainImg": "Unity/Unity-Fronts/Colour-Collection/Supermatt/Base-Cabs-Supermatt-Cashmere.png",
                "webCode": "bc12"
              },
              {
                "text": "Dust Grey",
                "sideImg": "Swatches/Unity-Fronts/Colour-Collection/Supermatt/Swatch-Base-Cabs-Supermatt-Dust_Grey.jpg",
                "mainImg": "Unity/Unity-Fronts/Colour-Collection/Supermatt/Base-Cabs-Supermatt-Dust_Grey.png",
                "webCode": "bc13"
              },
              {
                "text": "Reed Green",
                "sideImg": "Swatches/Unity-Fronts/Colour-Collection/Supermatt/Swatch-Base-Cabs-Supermatt-Reed_Green.jpg",
                "mainImg": "Unity/Unity-Fronts/Colour-Collection/Supermatt/Base-Cabs-Supermatt-Reed_Green.png",
                "webCode": "bc14"
              },
              {
                "text": "Thorpe Green",
                "sideImg": "Swatches/Unity-Fronts/Colour-Collection/Supermatt/Swatch-Base-Cabs-Supermatt-Thorpe_Green.jpg",
                "mainImg": "Unity/Unity-Fronts/Colour-Collection/Supermatt/Base-Cabs-Supermatt-Thorpe_Green.png",
                "webCode": "bc15"
              },
              {
                "text": "Graphite",
                "sideImg": "Swatches/Unity-Fronts/Colour-Collection/Supermatt/Swatch-Base-Cabs-Supermatt-Graphite.jpg",
                "mainImg": "Unity/Unity-Fronts/Colour-Collection/Supermatt/Base-Cabs-Supermatt-Graphite.png",
                "webCode": "bc16"
              },
              {
                "text": "Indigo Blue",
                "sideImg": "Swatches/Unity-Fronts/Colour-Collection/Supermatt/Swatch-Base-Cabs-Supermatt-Indigo_Blue.jpg",
                "mainImg": "Unity/Unity-Fronts/Colour-Collection/Supermatt/Base-Cabs-Supermatt-Indigo_Blue.png",
                "webCode": "bc17"
              },              
              {
                "text": "Soft Carbon",
                "sideImg": "Swatches/Unity-Fronts/Colour-Collection/Supermatt/Swatch-Base-Cabs-Supermatt-Soft_Carbon.jpg",
                "mainImg": "Unity/Unity-Fronts/Colour-Collection/Supermatt/Base-Cabs-Supermatt-Soft_Carbon.png",
                "webCode": "bc18"
              },             
            ]
          },
          {
            "text": "Colour Collection - Gloss",
            "sideCode": "",
            "mainImg": "",
            "fontAwesome": false,
            "childSubMenu": [
              {
                "text": "White",
                "sideImg": "Swatches/Unity-Fronts/Colour-Collection/Gloss/Swatch-Base-Cabs-Gloss-White.jpg",
                "mainImg": "Unity/Unity-Fronts/Colour-Collection/Gloss/Base-Cabs-Gloss-White.png",
                "webCode": "bc19"
              },
              {
                "text": "Light Grey",
                "sideImg": "Swatches/Unity-Fronts/Colour-Collection/Gloss/Swatch-Base-Cabs-Gloss-Light_Grey.jpg",
                "mainImg": "Unity/Unity-Fronts/Colour-Collection/Gloss/Base-Cabs-Gloss-Light_Grey.png",
                "webCode": "bc20"
              },
              {
                "text": "Taupe Grey",
                "sideImg": "Swatches/Unity-Fronts/Colour-Collection/Gloss/Swatch-Base-Cabs-Gloss-Taupe_Grey.jpg",
                "mainImg": "Unity/Unity-Fronts/Colour-Collection/Gloss/Base-Cabs-Gloss-Taupe_Grey.png",
                "webCode": "bc21"
              },
              {
                "text": "Cashmere",
                "sideImg": "Swatches/Unity-Fronts/Colour-Collection/Gloss/Swatch-Base-Cabs-Gloss-Cashmere.jpg",
                "mainImg": "Unity/Unity-Fronts/Colour-Collection/Gloss/Base-Cabs-Gloss-Cashmere.png",
                "webCode": "bc22"
              },
              {
                "text": "Dust Grey",
                "sideImg": "Swatches/Unity-Fronts/Colour-Collection/Gloss/Swatch-Base-Cabs-Gloss-Dust_Grey.jpg",
                "mainImg": "Unity/Unity-Fronts/Colour-Collection/Gloss/Base-Cabs-Gloss-Dust_Grey.png",
                "webCode": "bc23"
              },
              {
                "text": "Graphite",
                "sideImg": "Swatches/Unity-Fronts/Colour-Collection/Gloss/Swatch-Base-Cabs-Gloss-Graphite.jpg",
                "mainImg": "Unity/Unity-Fronts/Colour-Collection/Gloss/Base-Cabs-Gloss-Graphite.png",
                "webCode": "bc24"
              },              
            ]
          },
          {
            "text": "Colour Collection - Gloss Metallic",
            "sideCode": "",
            "mainImg": "",
            "fontAwesome": false,
            "childSubMenu": [
              {
                "text": "Gold",
                "sideImg": "Swatches/Unity-Fronts/Colour-Collection/Gloss-Metallic/Swatch-Base-Cabs-Gloss-Metallic-Gold.jpg",
                "mainImg": "Unity/Unity-Fronts/Colour-Collection/Gloss-Metallic/Base-Cabs-Gloss-Metallic-Gold.png",
                "webCode": "bc25"
              },
              {
                "text": "Fjord",
                "sideImg": "Swatches/Unity-Fronts/Colour-Collection/Gloss-Metallic/Swatch-Base-Cabs-Gloss-Metallic-Fjord.jpg",
                "mainImg": "Unity/Unity-Fronts/Colour-Collection/Gloss-Metallic/Base-Cabs-Gloss-Metallic-Fjord.png",
                "webCode": "bc26"
              },
            ]
          },
          {
            "text": "Luxe Collection - Luxe Metallic",
            "sideCode": "",
            "mainImg": "",
            "fontAwesome": false,
            "childSubMenu": [
              {
                "text": "Steel Metallic",
                "sideImg": "Swatches/Unity-Fronts/Luxe-Collection/Luxe-Metallic/Swatch-Base-Cabs-Luxe-Metallic-Steel_Metallic.jpg",
                "mainImg": "Unity/Unity-Fronts/Luxe-Collection/Luxe-Metallic/Base-Cabs-Luxe-Metallic-Steel_Metallic.png",
                "webCode": "bc27"
              },
              {
                "text": "Bronze Metallic",
                "sideImg": "Swatches/Unity-Fronts/Luxe-Collection/Luxe-Metallic/Swatch-Base-Cabs-Luxe-Metallic-Bronze_Metallic.jpg",
                "mainImg": "Unity/Unity-Fronts/Luxe-Collection/Luxe-Metallic/Base-Cabs-Luxe-Metallic-Bronze_Metallic.png",
                "webCode": "bc28"
              },
              {
                "text": "Anthracite Metallic",
                "sideImg": "Swatches/Unity-Fronts/Luxe-Collection/Luxe-Metallic/Swatch-Base-Cabs-Luxe-Metallic-Anthracite_Metallic.jpg",
                "mainImg": "Unity/Unity-Fronts/Luxe-Collection/Luxe-Metallic/Base-Cabs-Luxe-Metallic-Anthracite_Metallic.png",
                "webCode": "bc29"
              },
            ]
          },
          {
            "text": "Luxe Collection - Brushed Metallic",
            "sideCode": "",
            "mainImg": "",
            "fontAwesome": false,
            "childSubMenu": [
              {
                "text": "Brushed Champagne",
                "sideImg": "Swatches/Unity-Fronts/Luxe-Collection/Brushed-Metallic/Swatch-Base-Cabs-Brushed-Metallic-Brushed_Champagne.jpg",
                "mainImg": "Unity/Unity-Fronts/Luxe-Collection/Brushed-Metallic/Base-Cabs-Brushed-Metallic-Brushed_Champagne.png",
                "webCode": "bc30"
              },
              {
                "text": "Brushed Bronze",
                "sideImg": "Swatches/Unity-Fronts/Luxe-Collection/Brushed-Metallic/Swatch-Base-Cabs-Brushed-Metallic-Brushed_Bronze.jpg",
                "mainImg": "Unity/Unity-Fronts/Luxe-Collection/Brushed-Metallic/Base-Cabs-Brushed-Metallic-Brushed_Bronze.png",
                "webCode": "bc31"
              },
              {
                "text": "Brushed Anthracite",
                "sideImg": "Swatches/Unity-Fronts/Luxe-Collection/Brushed-Metallic/Swatch-Base-Cabs-Brushed-Metallic-Brushed_Anthracite.jpg",
                "mainImg": "Unity/Unity-Fronts/Luxe-Collection/Brushed-Metallic/Base-Cabs-Brushed-Metallic-Brushed_Anthracite.png",
                "webCode": "bc32"
              },
              
            ]
          },
          //{
          //  "text": "Luxe Collection - Anodised Metallic",
          //  "sideCode": "",
          //  "mainImg": "",
          //  "fontAwesome": false,
          //  "childSubMenu": [
          //    {
          //      "text": "Oxidised Bronze",
          //      "sideImg": "Swatches/Unity-Fronts/Luxe-Collection/Anodised-Metallic/Swatch-Base-Cabs-Anodised-Metallic-Oxidized_Bronze.jpg",
          //      "mainImg": "Unity/Unity-Fronts/Luxe-Collection/Anodised-Metallic/Base-Cabs-Anodised-Metallic-Oxidized_Bronze.png",
          //      "webCode": "bc33"
          //    },
          //    {
          //      "text": "Oxidised Anthracite",
          //      "sideImg": "Swatches/Unity-Fronts/Luxe-Collection/Anodised-Metallic/Swatch-Base-Cabs-Anodised-Metallic-Oxidized_Anthracite.jpg",
          //      "mainImg": "Unity/Unity-Fronts/Luxe-Collection/Anodised-Metallic/Base-Cabs-Anodised-Metallic-Oxidized_Anthracite.png",
          //      "webCode": "bc34"
          //    },
          //  ]
          //},
          {
            "text": "Stone Collection - Concrete",
            "sideCode": "",
            "mainImg": "",
            "fontAwesome": false,
            "childSubMenu": [
              {
                "text": "Hayward",
                "sideImg": "Swatches/Unity-Fronts/Stone-Collection/Concrete/Swatch-Base-Cabs-Concrete-Hayward.jpg",
                "mainImg": "Unity/Unity-Fronts/Stone-Collection/Concrete/Base-Cabs-Concrete-Hayward.png",
                "webCode": "bc35"
              },
              {
                "text": "Trellick Concrete",
                "sideImg": "Swatches/Unity-Fronts/Stone-Collection/Concrete/Swatch-Base-Cabs-Concrete-Trellick_Concrete.jpg",
                "mainImg": "Unity/Unity-Fronts/Stone-Collection/Concrete/Base-Cabs-Concrete-Trellick_Concrete.png",
                "webCode": "bc36"
              },
              {
                "text": "Banham Concrete",
                "sideImg": "Swatches/Unity-Fronts/Stone-Collection/Concrete/Swatch-Base-Cabs-Concrete-Banham_Concrete.jpg",
                "mainImg": "Unity/Unity-Fronts/Stone-Collection/Concrete/Base-Cabs-Concrete-Banham_Concrete.png",
                "webCode": "bc37"
              },
            ]
          },
          {
            "text": "Stone Collection - Marble",
            "sideCode": "",
            "mainImg": "",
            "fontAwesome": false,
            "childSubMenu": [
              {
                "text": "White Statuario",
                "sideImg": "Swatches/Unity-Fronts/Stone-Collection/Marble/Swatch-Base-Cabs-Marble-White_Statuario.jpg",
                "mainImg": "Unity/Unity-Fronts/Stone-Collection/Marble/Base-Cabs-Marble-White_Statuario.png",
                "webCode": "bc38"
              },
              {
                "text": "Mocha Pietra",
                "sideImg": "Swatches/Unity-Fronts/Stone-Collection/Marble/Swatch-Base-Cabs-Marble-Mocha_Pietra.jpg",
                "mainImg": "Unity/Unity-Fronts/Stone-Collection/Marble/Base-Cabs-Marble-Mocha_Pietra.png",
                "webCode": "bc39"
              },
              {
                "text": "Black Marquina",
                "sideImg": "Swatches/Unity-Fronts/Stone-Collection/Marble/Swatch-Base-Cabs-Marble-Black_Marquina.jpg",
                "mainImg": "Unity/Unity-Fronts/Stone-Collection/Marble/Base-Cabs-Marble-Black_Marquina.png",
                "webCode": "bc40"
              },             
            ]
          },
          {
            "text": "Woodgrain Collection - Linear",
            "sideCode": "",
            "mainImg": "",
            "fontAwesome": false,
            "childSubMenu": [
              {
                "text": "Natural Oak Linear",
                "sideImg": "Swatches/Unity-Fronts/Woodgrain-Collection/Linear/Swatch-Base-Cabs-Linear-Natural_Oak_Linear.jpg",
                "mainImg": "Unity/Unity-Fronts/Woodgrain-Collection/Linear/Base-Cabs-Linear-Natural_Oak_Linear.png",
                "webCode": "bc41"
              },
              {
                "text": "Tobacco Oak Linear",
                "sideImg": "Swatches/Unity-Fronts/Woodgrain-Collection/Linear/Swatch-Base-Cabs-Linear-Tobacco_Oak_Linear.jpg",
                "mainImg": "Unity/Unity-Fronts/Woodgrain-Collection/Linear/Base-Cabs-Linear-Tobacco_Oak_Linear.png",
                "webCode": "bc42"
              },
              {
                "text": "Black Oak Linear",
                "sideImg": "Swatches/Unity-Fronts/Woodgrain-Collection/Linear/Swatch-Base-Cabs-Linear-Black_Oak_Linear.jpg",
                "mainImg": "Unity/Unity-Fronts/Woodgrain-Collection/Linear/Base-Cabs-Linear-Black_Oak_Linear.png",
                "webCode": "bc43"
              },
            ]
          },
          {
            "text": "Woodgrain Collection - Rustic",
            "sideCode": "",
            "mainImg": "",
            "fontAwesome": false,
            "childSubMenu": [
              {
                "text": "Natural Oak Montane",
                "sideImg": "Swatches/Unity-Fronts/Woodgrain-Collection/Rustic/Swatch-Base-Cabs-Rustic-Natural_Oak_Montane.jpg",
                "mainImg": "Unity/Unity-Fronts/Woodgrain-Collection/Rustic/Base-Cabs-Rustic-Natural_Oak_Montane.png",
                "webCode": "bc44"
              },
              {
                "text": "Washed Walnut Montane",
                "sideImg": "Swatches/Unity-Fronts/Woodgrain-Collection/Rustic/Swatch-Base-Cabs-Rustic-Washed_Walnut_Montane.jpg",
                "mainImg": "Unity/Unity-Fronts/Woodgrain-Collection/Rustic/Base-Cabs-Rustic-Washed_Walnut_Montane.png",
                "webCode": "bc45"
              },
              {
                "text": "Tobacco Oak Montane",
                "sideImg": "Swatches/Unity-Fronts/Woodgrain-Collection/Rustic/Swatch-Base-Cabs-Rustic-Tobacco_Oak_Montane.jpg",
                "mainImg": "Unity/Unity-Fronts/Woodgrain-Collection/Rustic/Base-Cabs-Rustic-Tobacco_Oak_Montane.png",
                "webCode": "bc46"
              },
            ]
          },
          {
            "text": "Woodgrain Collection - Natural",
            "sideCode": "",
            "mainImg": "",
            "fontAwesome": false,
            "childSubMenu": [
              {
                "text": "White Halifax Oak",
                "sideImg": "Swatches/Unity-Fronts/Woodgrain-Collection/Natural/Swatch-Base-Cabs-Natural-White_Halifax_Oak.jpg",
                "mainImg": "Unity/Unity-Fronts/Woodgrain-Collection/Natural/Base-Cabs-Natural-White_Halifax_Oak.png",
                "webCode": "bc47"
              },
              {
                "text": "Natural Davos Oak",
                "sideImg": "Swatches/Unity-Fronts/Woodgrain-Collection/Natural/Swatch-Base-Cabs-Natural-Natural_Davos_Oak.jpg",
                "mainImg": "Unity/Unity-Fronts/Woodgrain-Collection/Natural/Base-Cabs-Natural-Natural_Davos_Oak.png",
                "webCode": "bc48"
              },
              {
                "text": "Grey Bardolino Oak",
                "sideImg": "Swatches/Unity-Fronts/Woodgrain-Collection/Natural/Swatch-Base-Cabs-Natural-Grey_Bardolino_Oak.jpg",
                "mainImg": "Unity/Unity-Fronts/Woodgrain-Collection/Natural/Base-Cabs-Natural-Grey_Bardolino_Oak.png",
                "webCode": "bc49"
              },
              {
                "text": "Natural Halifax Oak",
                "sideImg": "Swatches/Unity-Fronts/Woodgrain-Collection/Natural/Swatch-Base-Cabs-Natural-Natural_Halifax_Oak.jpg",
                "mainImg": "Unity/Unity-Fronts/Woodgrain-Collection/Natural/Base-Cabs-Natural-Natural_Halifax_Oak.png",
                "webCode": "bc50"
              },
              {
                "text": "Lincoln Walnut",
                "sideImg": "Swatches/Unity-Fronts/Woodgrain-Collection/Natural/Swatch-Base-Cabs-Natural-Lincoln_Walnut.jpg",
                "mainImg": "Unity/Unity-Fronts/Woodgrain-Collection/Natural/Base-Cabs-Natural-Lincoln_Walnut.png",
                "webCode": "bc51"
              },
              {
                "text": "Brown Orleans Oak",
                "sideImg": "Swatches/Unity-Fronts/Woodgrain-Collection/Natural/Swatch-Base-Cabs-Natural-Brown_Orleans_Oak.jpg",
                "mainImg": "Unity/Unity-Fronts/Woodgrain-Collection/Natural/Base-Cabs-Natural-Brown_Orleans_Oak.png",
                "webCode": "bc52"
              },
              {
                "text": "Marone Casella Oak",
                "sideImg": "Swatches/Unity-Fronts/Woodgrain-Collection/Natural/Swatch-Base-Cabs-Natural-Marone_Casella_Oak.jpg",
                "mainImg": "Unity/Unity-Fronts/Woodgrain-Collection/Natural/Base-Cabs-Natural-Marone_Casella_Oak.png",
                "webCode": "bc53"
              },
              {
                "text": "Shadow Black",
                "sideImg": "Swatches/Unity-Fronts/Woodgrain-Collection/Natural/Swatch-Base-Cabs-Natural-Shadow_Black.jpg",
                "mainImg": "Unity/Unity-Fronts/Woodgrain-Collection/Natural/Base-Cabs-Natural-Shadow_Black.png",
                "webCode": "bc54"
              },
            ]
          },
          {
            "text": "Woodgrain Collection - Striped",
            "sideCode": "",
            "mainImg": "",
            "fontAwesome": false,
            "childSubMenu": [
              {
                "text": "Light Oak Striped",
                "sideImg": "Swatches/Unity-Fronts/Woodgrain-Collection/Striped/Swatch-Base-Cabs-Striped-Light_Oak_Striped.jpg",
                "mainImg": "Unity/Unity-Fronts/Woodgrain-Collection/Striped/Base-Cabs-Striped-Light_Oak_Striped.png",
                "webCode": "bc55"
              },
              {
                "text": "Dark Oak Striped",
                "sideImg": "Swatches/Unity-Fronts/Woodgrain-Collection/Striped/Swatch-Base-Cabs-Striped-Dark_Oak_Striped.jpg",
                "mainImg": "Unity/Unity-Fronts/Woodgrain-Collection/Striped/Base-Cabs-Striped-Dark_Oak_Striped.png",
                "webCode": "bc56"
              },
            ]
          }
        ]
      },
      {
        "text": "Wall Cabinet Fronts",
        "textPosition": "menu",
        "imgCode": "Main_Icons/Wall_Cabinet_Fronts",
        "id": "block-2",
        "imgTxtOnly": true,
        "fontAwesome": false,
        "listType": "checkbox",
        "subMenu": [
          {
            "text": "Colour Collection - Deluxe Supermatt",
            "sideCode": "",
            "mainImg": "",
            "fontAwesome": false,
            "childSubMenu": [
              {
                "text": "Lotus White",
                "sideImg": "Swatches/Unity-Wall-Cab-Fronts/Colour-Collection/Deluxe-Supermatt/Swatch-Wall-Cabs-Deluxe-Supermatt-Lotus_White.jpg",
                "mainImg": "Unity/Unity-Wall-Cab-Fronts/Colour-Collection/Deluxe-Supermatt/Wall-Cabs-Deluxe-Supermatt-Lotus_White.png",
                "webCode": "wc1"
              },
              {
                "text": "Salt Grey",
                "sideImg": "Swatches/Unity-Wall-Cab-Fronts/Colour-Collection/Deluxe-Supermatt/Swatch-Wall-Cabs-Deluxe-Supermatt-Salt_Grey.jpg",
                "mainImg": "Unity/Unity-Wall-Cab-Fronts/Colour-Collection/Deluxe-Supermatt/Wall-Cabs-Deluxe-Supermatt-Salt_Grey.png",
                "webCode": "wc2"
              },
              {
                "text": "Sandstone",
                "sideImg": "Swatches/Unity-Wall-Cab-Fronts/Colour-Collection/Deluxe-Supermatt/Swatch-Wall-Cabs-Deluxe-Supermatt-Sandstone.jpg",
                "mainImg": "Unity/Unity-Wall-Cab-Fronts/Colour-Collection/Deluxe-Supermatt/Wall-Cabs-Deluxe-Supermatt-Sandstone.png",
                "webCode": "wc3"
              },
              {
                "text": "Moss",
                "sideImg": "Swatches/Unity-Wall-Cab-Fronts/Colour-Collection/Deluxe-Supermatt/Swatch-Wall-Cabs-Deluxe-Supermatt-Moss.jpg",
                "mainImg": "Unity/Unity-Wall-Cab-Fronts/Colour-Collection/Deluxe-Supermatt/Wall-Cabs-Deluxe-Supermatt-Moss.png",
                "webCode": "wc4"
              },
              {
                "text": "Flint",
                "sideImg": "Swatches/Unity-Wall-Cab-Fronts/Colour-Collection/Deluxe-Supermatt/Swatch-Wall-Cabs-Deluxe-Supermatt-Flint.jpg",
                "mainImg": "Unity/Unity-Wall-Cab-Fronts/Colour-Collection/Deluxe-Supermatt/Wall-Cabs-Deluxe-Supermatt-Flint.png",
                "webCode": "wc5"
              },
              {
                "text": "Oxford Blue",
                "sideImg": "Swatches/Unity-Wall-Cab-Fronts/Colour-Collection/Deluxe-Supermatt/Swatch-Wall-Cabs-Deluxe-Supermatt-Oxford_Blue.jpg",
                "mainImg": "Unity/Unity-Wall-Cab-Fronts/Colour-Collection/Deluxe-Supermatt/Wall-Cabs-Deluxe-Supermatt-Oxford_Blue.png",
                "webCode": "wc6"
              },
              {
                "text": "Onyx Nero",
                "sideImg": "Swatches/Unity-Wall-Cab-Fronts/Colour-Collection/Deluxe-Supermatt/Swatch-Wall-Cabs-Deluxe-Supermatt-Onyx_Nero.jpg",
                "mainImg": "Unity/Unity-Wall-Cab-Fronts/Colour-Collection/Deluxe-Supermatt/Wall-Cabs-Deluxe-Supermatt-Onyx_Nero.png",
                "webCode": "wc7"
              },
              {
                "text": "Bordeaux",
                "sideImg": "Swatches/Unity-Wall-Cab-Fronts/Colour-Collection/Deluxe-Supermatt/Swatch-Wall-Cabs-Deluxe-Supermatt-Bordeaux.jpg",
                "mainImg": "Unity/Unity-Wall-Cab-Fronts/Colour-Collection/Deluxe-Supermatt/Wall-Cabs-Deluxe-Supermatt-Bordeaux.png",
                "webCode": "wc8"
              },
            ]
          },
          {
            "text": "Colour Collection - Supermatt",
            "sideCode": "",
            "mainImg": "",
            "fontAwesome": false,
            "childSubMenu": [
              {
                "text": "Pure White",
                "sideImg": "Swatches/Unity-Wall-Cab-Fronts/Colour-Collection/Supermatt/Swatch-Wall-Cabs-Supermatt-Pure_White.jpg",
                "mainImg": "Unity/Unity-Wall-Cab-Fronts/Colour-Collection/Supermatt/Wall-Cabs-Supermatt-Pure_White.png",
                "webCode": "wc9"
              },
              {
                "text": "Light Grey",
                "sideImg": "Swatches/Unity-Wall-Cab-Fronts/Colour-Collection/Supermatt/Swatch-Wall-Cabs-Supermatt-Light_Grey.jpg",
                "mainImg": "Unity/Unity-Wall-Cab-Fronts/Colour-Collection/Supermatt/Wall-Cabs-Supermatt-Light_Grey.png",
                "webCode": "wc10"
              },
              {
                "text": "Taupe Grey",
                "sideImg": "Swatches/Unity-Wall-Cab-Fronts/Colour-Collection/Supermatt/Swatch-Wall-Cabs-Supermatt-Taupe_Grey.jpg",
                "mainImg": "Unity/Unity-Wall-Cab-Fronts/Colour-Collection/Supermatt/Wall-Cabs-Supermatt-Taupe_Grey.png",
                "webCode": "wc11"
              },
              {
                "text": "Cashmere",
                "sideImg": "Swatches/Unity-Wall-Cab-Fronts/Colour-Collection/Supermatt/Swatch-Wall-Cabs-Supermatt-Cashmere.jpg",
                "mainImg": "Unity/Unity-Wall-Cab-Fronts/Colour-Collection/Supermatt/Wall-Cabs-Supermatt-Cashmere.png",
                "webCode": "wc12"
              },
              {
                "text": "Dust Grey",
                "sideImg": "Swatches/Unity-Wall-Cab-Fronts/Colour-Collection/Supermatt/Swatch-Wall-Cabs-Supermatt-Dust_Grey.jpg",
                "mainImg": "Unity/Unity-Wall-Cab-Fronts/Colour-Collection/Supermatt/Wall-Cabs-Supermatt-Dust_Grey.png",
                "webCode": "wc13"
              },
              {
                "text": "Reed Green",
                "sideImg": "Swatches/Unity-Wall-Cab-Fronts/Colour-Collection/Supermatt/Swatch-Wall-Cabs-Supermatt-Reed_Green.jpg",
                "mainImg": "Unity/Unity-Wall-Cab-Fronts/Colour-Collection/Supermatt/Wall-Cabs-Supermatt-Reed_Green.png",
                "webCode": "wc14"
              },
              {
                "text": "Thorpe Green",
                "sideImg": "Swatches/Unity-Wall-Cab-Fronts/Colour-Collection/Supermatt/Swatch-Wall-Cabs-Supermatt-Thorpe_Green.jpg",
                "mainImg": "Unity/Unity-Wall-Cab-Fronts/Colour-Collection/Supermatt/Wall-Cabs-Supermatt-Thorpe_Green.png",
                "webCode": "wc15"
              },
              {
                "text": "Graphite",
                "sideImg": "Swatches/Unity-Wall-Cab-Fronts/Colour-Collection/Supermatt/Swatch-Wall-Cabs-Supermatt-Graphite.jpg",
                "mainImg": "Unity/Unity-Wall-Cab-Fronts/Colour-Collection/Supermatt/Wall-Cabs-Supermatt-Graphite.png",
                "webCode": "wc16"
              },
              {
                "text": "Indigo Blue",
                "sideImg": "Swatches/Unity-Wall-Cab-Fronts/Colour-Collection/Supermatt/Swatch-Wall-Cabs-Supermatt-Indigo_Blue.jpg",
                "mainImg": "Unity/Unity-Wall-Cab-Fronts/Colour-Collection/Supermatt/Wall-Cabs-Supermatt-Indigo_Blue.png",
                "webCode": "wc17"
              },
              {
                "text": "Soft Carbon",
                "sideImg": "Swatches/Unity-Wall-Cab-Fronts/Colour-Collection/Supermatt/Swatch-Wall-Cabs-Supermatt-Soft_Carbon.jpg",
                "mainImg": "Unity/Unity-Wall-Cab-Fronts/Colour-Collection/Supermatt/Wall-Cabs-Supermatt-Soft_Carbon.png",
                "webCode": "wc18"
              },
            ]
          },
          {
            "text": "Colour Collection - Gloss",
            "sideCode": "",
            "mainImg": "",
            "fontAwesome": false,
            "childSubMenu": [
              {
                "text": "White",
                "sideImg": "Swatches/Unity-Wall-Cab-Fronts/Colour-Collection/Gloss/Swatch-Wall-Cabs-Gloss-White.jpg",
                "mainImg": "Unity/Unity-Wall-Cab-Fronts/Colour-Collection/Gloss/Wall-Cabs-Gloss-White.png",
                "webCode": "wc19"
              },
              {
                "text": "Light Grey",
                "sideImg": "Swatches/Unity-Wall-Cab-Fronts/Colour-Collection/Gloss/Swatch-Wall-Cabs-Gloss-Light_Grey.jpg",
                "mainImg": "Unity/Unity-Wall-Cab-Fronts/Colour-Collection/Gloss/Wall-Cabs-Gloss-Light_Grey.png",
                "webCode": "wc20"
              },
              {
                "text": "Taupe Grey",
                "sideImg": "Swatches/Unity-Wall-Cab-Fronts/Colour-Collection/Gloss/Swatch-Wall-Cabs-Gloss-Taupe_Grey.jpg",
                "mainImg": "Unity/Unity-Wall-Cab-Fronts/Colour-Collection/Gloss/Wall-Cabs-Gloss-Taupe_Grey.png",
                "webCode": "wc21"
              },
              {
                "text": "Cashmere",
                "sideImg": "Swatches/Unity-Wall-Cab-Fronts/Colour-Collection/Gloss/Swatch-Wall-Cabs-Gloss-Cashmere.jpg",
                "mainImg": "Unity/Unity-Wall-Cab-Fronts/Colour-Collection/Gloss/Wall-Cabs-Gloss-Cashmere.png",
                "webCode": "wc22"
              },
              {
                "text": "Dust Grey",
                "sideImg": "Swatches/Unity-Wall-Cab-Fronts/Colour-Collection/Gloss/Swatch-Wall-Cabs-Gloss-Dust_Grey.jpg",
                "mainImg": "Unity/Unity-Wall-Cab-Fronts/Colour-Collection/Gloss/Wall-Cabs-Gloss-Dust_Grey.png",
                "webCode": "wc23"
              },
              {
                "text": "Graphite",
                "sideImg": "Swatches/Unity-Wall-Cab-Fronts/Colour-Collection/Gloss/Swatch-Wall-Cabs-Gloss-Graphite.jpg",
                "mainImg": "Unity/Unity-Wall-Cab-Fronts/Colour-Collection/Gloss/Wall-Cabs-Gloss-Graphite.png",
                "webCode": "wc24"
              },
            ]
          },
          {
            "text": "Colour Collection - Gloss Metallic",
            "sideCode": "",
            "mainImg": "",
            "fontAwesome": false,
            "childSubMenu": [
              {
                "text": "Gold",
                "sideImg": "Swatches/Unity-Wall-Cab-Fronts/Colour-Collection/Gloss-Metallic/Swatch-Wall-Cabs-Gloss-Metallic-Gold.jpg",
                "mainImg": "Unity/Unity-Wall-Cab-Fronts/Colour-Collection/Gloss-Metallic/Wall-Cabs-Gloss-Metallic-Gold.png",
                "webCode": "wc25"
              },
              {
                "text": "Fjord",
                "sideImg": "Swatches/Unity-Wall-Cab-Fronts/Colour-Collection/Gloss-Metallic/Swatch-Wall-Cabs-Gloss-Metallic-Fjord.jpg",
                "mainImg": "Unity/Unity-Wall-Cab-Fronts/Colour-Collection/Gloss-Metallic/Wall-Cabs-Gloss-Metallic-Fjord.png",
                "webCode": "wc26"
              },
            ]
          },
          {
            "text": "Luxe Collection - Luxe Metallic",
            "sideCode": "",
            "mainImg": "",
            "fontAwesome": false,
            "childSubMenu": [
              {
                "text": "Steel Metallic",
                "sideImg": "Swatches/Unity-Wall-Cab-Fronts/Luxe-Collection/Luxe-Metallic/Swatch-Wall-Cabs-Luxe-Metallic-Steel_Metallic.jpg",
                "mainImg": "Unity/Unity-Wall-Cab-Fronts/Luxe-Collection/Luxe-Metallic/Wall-Cabs-Luxe-Metallic-Steel_Metallic.png",
                "webCode": "wc27"
              },
              {
                "text": "Bronze Metallic",
                "sideImg": "Swatches/Unity-Wall-Cab-Fronts/Luxe-Collection/Luxe-Metallic/Swatch-Wall-Cabs-Luxe-Metallic-Bronze_Metallic.jpg",
                "mainImg": "Unity/Unity-Wall-Cab-Fronts/Luxe-Collection/Luxe-Metallic/Wall-Cabs-Luxe-Metallic-Bronze_Metallic.png",
                "webCode": "wc28"
              },
              {
                "text": "Anthracite Metallic",
                "sideImg": "Swatches/Unity-Wall-Cab-Fronts/Luxe-Collection/Luxe-Metallic/Swatch-Wall-Cabs-Luxe-Metallic-Anthracite_Metallic.jpg",
                "mainImg": "Unity/Unity-Wall-Cab-Fronts/Luxe-Collection/Luxe-Metallic/Wall-Cabs-Luxe-Metallic-Anthracite_Metallic.png",
                "webCode": "wc29"
              },
            ]
          },
          {
            "text": "Luxe Collection - Brushed Metallic",
            "sideCode": "",
            "mainImg": "",
            "fontAwesome": false,
            "childSubMenu": [
              {
                "text": "Brushed Champagne",
                "sideImg": "Swatches/Unity-Wall-Cab-Fronts/Luxe-Collection/Brushed-Metallic/Swatch-Wall-Cabs-Brushed-Metallic-Brushed_Champagne.jpg",
                "mainImg": "Unity/Unity-Wall-Cab-Fronts/Luxe-Collection/Brushed-Metallic/Wall-Cabs-Brushed-Metallic-Brushed_Champagne.png",
                "webCode": "wc30"
              },
              {
                "text": "Brushed Bronze",
                "sideImg": "Swatches/Unity-Wall-Cab-Fronts/Luxe-Collection/Brushed-Metallic/Swatch-Wall-Cabs-Brushed-Metallic-Brushed_Bronze.jpg",
                "mainImg": "Unity/Unity-Wall-Cab-Fronts/Luxe-Collection/Brushed-Metallic/Wall-Cabs-Brushed-Metallic-Brushed_Bronze.png",
                "webCode": "wc31"
              },
              {
                "text": "Brushed Anthracite",
                "sideImg": "Swatches/Unity-Wall-Cab-Fronts/Luxe-Collection/Brushed-Metallic/Swatch-Wall-Cabs-Brushed-Metallic-Brushed_Anthracite.jpg",
                "mainImg": "Unity/Unity-Wall-Cab-Fronts/Luxe-Collection/Brushed-Metallic/Wall-Cabs-Brushed-Metallic-Brushed_Anthracite.png",
                "webCode": "wc32"
              },
            ]
          },
          {
            "text": "Luxe Collection - Anodised Metallic",
            "sideCode": "",
            "mainImg": "",
            "fontAwesome": false,
            "childSubMenu": [
              {
                "text": "Oxidised Bronze",
                "sideImg": "Swatches/Unity-Wall-Cab-Fronts/Luxe-Collection/Anodised-Metallic/Swatch-Wall-Cabs-Anodised-Metallic-Oxidized_Bronze.jpg",
                "mainImg": "Unity/Unity-Wall-Cab-Fronts/Luxe-Collection/Anodised-Metallic/Wall-Cabs-Anodised-Metallic-Oxidized_Bronze.png",
                "webCode": "wc33"
              },
              {
                "text": "Oxidised Anthracite",
                "sideImg": "Swatches/Unity-Wall-Cab-Fronts/Luxe-Collection/Anodised-Metallic/Swatch-Wall-Cabs-Anodised-Metallic-Oxidized_Anthracite.jpg",
                "mainImg": "Unity/Unity-Wall-Cab-Fronts/Luxe-Collection/Anodised-Metallic/Wall-Cabs-Anodised-Metallic-Oxidized_Anthracite.png",
                "webCode": "wc34"
              },
            ]
          },
          {
            "text": "Stone Collection - Concrete",
            "sideCode": "",
            "mainImg": "",
            "fontAwesome": false,
            "childSubMenu": [
              {
                "text": "Hayward",
                "sideImg": "Swatches/Unity-Wall-Cab-Fronts/Stone-Collection/Concrete/Swatch-Wall-Cabs-Concrete-Hayward.jpg",
                "mainImg": "Unity/Unity-Wall-Cab-Fronts/Stone-Collection/Concrete/Wall-Cabs-Concrete-Hayward.png",
                "webCode": "wc35"
              },
              {
                "text": "Trellick Concrete",
                "sideImg": "Swatches/Unity-Wall-Cab-Fronts/Stone-Collection/Concrete/Swatch-Wall-Cabs-Concrete-Trellick_Concrete.jpg",
                "mainImg": "Unity/Unity-Wall-Cab-Fronts/Stone-Collection/Concrete/Wall-Cabs-Concrete-Trellick_Concrete.png",
                "webCode": "wc36"
              },
              {
                "text": "Banham Concrete",
                "sideImg": "Swatches/Unity-Wall-Cab-Fronts/Stone-Collection/Concrete/Swatch-Wall-Cabs-Concrete-Banham_Concrete.jpg",
                "mainImg": "Unity/Unity-Wall-Cab-Fronts/Stone-Collection/Concrete/Wall-Cabs-Concrete-Banham_Concrete.png",
                "webCode": "wc37"
              },
            ]
          },
          {
            "text": "Stone Collection - Marble",
            "sideCode": "",
            "mainImg": "",
            "fontAwesome": false,
            "childSubMenu": [
              {
                "text": "White Statuario",
                "sideImg": "Swatches/Unity-Wall-Cab-Fronts/Stone-Collection/Marble/Swatch-Wall-Cabs-Marble-White_Statuario.jpg",
                "mainImg": "Unity/Unity-Wall-Cab-Fronts/Stone-Collection/Marble/Wall-Cabs-Marble-White_Statuario.png",
                "webCode": "wc38"
              },
              {
                "text": "Mocha Pietra",
                "sideImg": "Swatches/Unity-Wall-Cab-Fronts/Stone-Collection/Marble/Swatch-Wall-Cabs-Marble-Mocha_Pietra.jpg",
                "mainImg": "Unity/Unity-Wall-Cab-Fronts/Stone-Collection/Marble/Wall-Cabs-Marble-Mocha_Pietra.png",
                "webCode": "wc39"
              },
              {
                "text": "Black Marquina",
                "sideImg": "Swatches/Unity-Wall-Cab-Fronts/Stone-Collection/Marble/Swatch-Wall-Cabs-Marble-Black_Marquina.jpg",
                "mainImg": "Unity/Unity-Wall-Cab-Fronts/Stone-Collection/Marble/Wall-Cabs-Marble-Black_Marquina.png",
                "webCode": "wc40"
              },
            ]
          },
          {
            "text": "Woodgrain Collection - Linear",
            "sideCode": "",
            "mainImg": "",
            "fontAwesome": false,
            "childSubMenu": [
              {
                "text": "Natural Oak Linear",
                "sideImg": "Swatches/Unity-Wall-Cab-Fronts/Woodgrain-Collection/Linear/Swatch-Wall-Cabs-Linear-Natural_Oak_Linear.jpg",
                "mainImg": "Unity/Unity-Wall-Cab-Fronts/Woodgrain-Collection/Linear/Wall-Cabs-Linear-Natural_Oak_Linear.png",
                "webCode": "wc41"
              },
              {
                "text": "Tobacco Oak Linear",
                "sideImg": "Swatches/Unity-Wall-Cab-Fronts/Woodgrain-Collection/Linear/Swatch-Wall-Cabs-Linear-Tobacco_Oak_Linear.jpg",
                "mainImg": "Unity/Unity-Wall-Cab-Fronts/Woodgrain-Collection/Linear/Wall-Cabs-Linear-Tobacco_Oak_Linear.png",
                "webCode": "wc42"
              },
              {
                "text": "Black Oak Linear",
                "sideImg": "Swatches/Unity-Wall-Cab-Fronts/Woodgrain-Collection/Linear/Swatch-Wall-Cabs-Linear-Black_Oak_Linear.jpg",
                "mainImg": "Unity/Unity-Wall-Cab-Fronts/Woodgrain-Collection/Linear/Wall-Cabs-Linear-Black_Oak_Linear.png",
                "webCode": "wc43"
              },
            ]
          },
          {
            "text": "Woodgrain Collection - Rustic",
            "sideCode": "",
            "mainImg": "",
            "fontAwesome": false,
            "childSubMenu": [
              {
                "text": "Natural Oak Montane",
                "sideImg": "Swatches/Unity-Wall-Cab-Fronts/Woodgrain-Collection/Rustic/Swatch-Wall-Cabs-Rustic-Natural_Oak_Montane.jpg",
                "mainImg": "Unity/Unity-Wall-Cab-Fronts/Woodgrain-Collection/Rustic/Wall-Cabs-Rustic-Natural_Oak_Montane.png",
                "webCode": "wc44"
              },
              {
                "text": "Washed Walnut Montane",
                "sideImg": "Swatches/Unity-Wall-Cab-Fronts/Woodgrain-Collection/Rustic/Swatch-Wall-Cabs-Rustic-Washed_Walnut_Montane.jpg",
                "mainImg": "Unity/Unity-Wall-Cab-Fronts/Woodgrain-Collection/Rustic/Wall-Cabs-Rustic-Washed_Walnut_Montane.png",
                "webCode": "wc45"
              },
              {
                "text": "Tobacco Oak Montane",
                "sideImg": "Swatches/Unity-Wall-Cab-Fronts/Woodgrain-Collection/Rustic/Swatch-Wall-Cabs-Rustic-Tobacco_Oak_Montane.jpg",
                "mainImg": "Unity/Unity-Wall-Cab-Fronts/Woodgrain-Collection/Rustic/Wall-Cabs-Rustic-Tobacco_Oak_Montane.png",
                "webCode": "wc46"
              },
            ]
          },
          {
            "text": "Woodgrain Collection - Natural",
            "sideCode": "",
            "mainImg": "",
            "fontAwesome": false,
            "childSubMenu": [
              {
                "text": "White Halifax Oak",
                "sideImg": "Swatches/Unity-Wall-Cab-Fronts/Woodgrain-Collection/Natural/Swatch-Wall-Cabs-Natural-White_Halifax_Oak.jpg",
                "mainImg": "Unity/Unity-Wall-Cab-Fronts/Woodgrain-Collection/Natural/Wall-Cabs-Natural-White_Halifax_Oak.png",
                "webCode": "wc47"
              },
              {
                "text": "Natural Davos Oak",
                "sideImg": "Swatches/Unity-Wall-Cab-Fronts/Woodgrain-Collection/Natural/Swatch-Wall-Cabs-Natural-Natural_Davos_Oak.jpg",
                "mainImg": "Unity/Unity-Wall-Cab-Fronts/Woodgrain-Collection/Natural/Wall-Cabs-Natural-Natural_Davos_Oak.png",
                "webCode": "wc48"
              },
              {
                "text": "Grey Bardolino Oak",
                "sideImg": "Swatches/Unity-Wall-Cab-Fronts/Woodgrain-Collection/Natural/Swatch-Wall-Cabs-Natural-Grey_Bardolino_Oak.jpg",
                "mainImg": "Unity/Unity-Wall-Cab-Fronts/Woodgrain-Collection/Natural/Wall-Cabs-Natural-Grey_Bardolino_Oak.png",
                "webCode": "wc49"
              },
              {
                "text": "Natural Halifax Oak",
                "sideImg": "Swatches/Unity-Wall-Cab-Fronts/Woodgrain-Collection/Natural/Swatch-Wall-Cabs-Natural-Natural_Halifax_Oak.jpg",
                "mainImg": "Unity/Unity-Wall-Cab-Fronts/Woodgrain-Collection/Natural/Wall-Cabs-Natural-Natural_Halifax_Oak.png",
                "webCode": "wc50"
              },
              {
                "text": "Lincoln Walnut",
                "sideImg": "Swatches/Unity-Wall-Cab-Fronts/Woodgrain-Collection/Natural/Swatch-Wall-Cabs-Natural-Lincoln_Walnut.jpg",
                "mainImg": "Unity/Unity-Wall-Cab-Fronts/Woodgrain-Collection/Natural/Wall-Cabs-Natural-Lincoln_Walnut.png",
                "webCode": "wc51"
              },
              {
                "text": "Brown Orleans Oak",
                "sideImg": "Swatches/Unity-Wall-Cab-Fronts/Woodgrain-Collection/Natural/Swatch-Wall-Cabs-Natural-Brown_Orleans_Oak.jpg",
                "mainImg": "Unity/Unity-Wall-Cab-Fronts/Woodgrain-Collection/Natural/Wall-Cabs-Natural-Brown_Orleans_Oak.png",
                "webCode": "wc52"
              },
              {
                "text": "Marone Casella Oak",
                "sideImg": "Swatches/Unity-Wall-Cab-Fronts/Woodgrain-Collection/Natural/Swatch-Wall-Cabs-Natural-Marone_Casella_Oak.jpg",
                "mainImg": "Unity/Unity-Wall-Cab-Fronts/Woodgrain-Collection/Natural/Wall-Cabs-Natural-Marone_Casella_Oak.png",
                "webCode": "wc53"
              },
              {
                "text": "Shadow Black",
                "sideImg": "Swatches/Unity-Wall-Cab-Fronts/Woodgrain-Collection/Natural/Swatch-Wall-Cabs-Natural-Shadow_Black.jpg",
                "mainImg": "Unity/Unity-Wall-Cab-Fronts/Woodgrain-Collection/Natural/Wall-Cabs-Natural-Shadow_Black.png",
                "webCode": "wc54"
              },

            ]
          },
          {
            "text": "Woodgrain Collection - Striped",
            "sideCode": "",
            "mainImg": "",
            "fontAwesome": false,
            "childSubMenu": [
              {
                "text": "Light Oak Striped",
                "sideImg": "Swatches/Unity-Wall-Cab-Fronts/Woodgrain-Collection/Striped/Swatch-Wall-Cabs-Striped-Light_Oak_Striped.jpg",
                "mainImg": "Unity/Unity-Wall-Cab-Fronts/Woodgrain-Collection/Striped/Wall-Cabs-Striped-Light_Oak_Striped.png",
                "webCode": "wc55"
              },
              {
                "text": "Dark Oak Striped",
                "sideImg": "Swatches/Unity-Wall-Cab-Fronts/Woodgrain-Collection/Striped/Swatch-Wall-Cabs-Striped-Dark_Oak_Striped.jpg",
                "mainImg": "Unity/Unity-Wall-Cab-Fronts/Woodgrain-Collection/Striped/Wall-Cabs-Striped-Dark_Oak_Striped.png",
                "webCode": "wc56"
              },
            ]
          }
        ]
      },
    ],
  },
  {
    "text": "Worktop",
    "textPosition": "side-menu",
    "imgCode": "Main_Icons/Worksurface",
    "id": "block-3",
    "imgTxtOnly": false,
    "fontAwesome": false,
    "listType": "medium",
    "groupList": false,
    "subMenu": [
      {
        "text": "Briliant White",
        "sideCode": "Swatches/Worksurfaces/Swatch-Worksurface-Brilliant_White.jpg",
        "mainImg": "Unity/Worksurfaces/Worksurface-Brilliant_White.png",
        "fontAwesome": false,
        "webCode": "ws1"
      },
      {
        "text": "Calacatta Silver",
        "sideCode": "Swatches/Worksurfaces/Swatch-Worksurface-Calacatta_Silver.jpg",
        "mainImg": "Unity/Worksurfaces/Worksurface-Calacatta_Silver.png",
        "fontAwesome": false,
        "webCode": "ws2"
      },
      {
        "text": "Mayville Concrete",
        "sideCode": "Swatches/Worksurfaces/Swatch-Worksurface-Mayville_Concrete.jpg",
        "mainImg": "Unity/Worksurfaces/Worksurface-Mayville_Concrete.png",
        "fontAwesome": false,
        "webCode": "ws3"
      },
      {
        "text": "Trinity Concrete",
        "sideCode": "Swatches/Worksurfaces/Swatch-Worksurface-Trinity_Concrete.jpg",
        "mainImg": "Unity/Worksurfaces/Worksurface-Trinity_Concrete.png",
        "fontAwesome": false,
        "webCode": "ws4"
      },
      {
        "text": "Premium Black",
        "sideCode": "Swatches/Worksurfaces/Swatch-Worksurface-Premium_Black.jpg",
        "mainImg": "Unity/Worksurfaces/Worksurface-Premium_Black.png",
        "fontAwesome": false,
        "webCode": "ws5"
      },
    ]
  },
  {
    "text": "Handle Options",
    "textPosition": "side-menu",
    "imgCode": "Main_Icons/Handles",
    "id": "block-4",
    "imgTxtOnly": false,
    "fontAwesome": false,
    "listType": "checkbox",
    "groupList" : true,
    "subMenu": [
      {
        "text": "",
        "sideCode": "",
        "mainImg": "",
        "fontAwesome": false,
        "childSubMenu": [
          {
            "text": "No Handle",
            "sideImg": "",
            "mainImg": "Unity/Handles/No_Handle.png",
            "webCode": "h1"
          }
        ]
      },
      {
        "text": "Cup Handle",
        "sideCode": "Swatches/Handles/Swatch-Cup-Handle.jpg",
        "mainImg": "",
        "fontAwesome": false,
        "childSubMenu": [
          {
            "text": "Lloyd Cup Handle - Brass",
            "sideImg": "",
            "mainImg": "Unity/Handles/Cup-Handle/Cup-Handle-Brass.png",
            "webCode": "h2"
          },
          {
            "text": "Lloyd Cup Handle - Black",
            "sideImg": "",
            "mainImg": "Unity/Handles/Cup-Handle/Cup-Handle-Black.png",
            "webCode": "h3"
          },
          {
            "text": "Lloyd Cup Handle - Stainless Steel",
            "sideImg": "",
            "mainImg": "Unity/Handles/Cup-Handle/Cup-Handle-Stainless_Steel.png",
            "webCode": "h4"
          }
        ]
      },
      {
        "text": "D Handle",
        "sideCode": "Swatches/Handles/Swatch-D-Handle.jpg",
        "mainImg": "",
        "fontAwesome": false,
        "childSubMenu": [
          {
            "text": "Lloyd D Handle - Brass",
            "sideImg": "",
            "mainImg": "Unity/Handles/D-Handle/D-Handle-Brass.png",
            "webCode": "h5"
          },
          {
            "text": "Lloyd D Handle - Black",
            "sideImg": "",
            "mainImg": "Unity/Handles/D-Handle/D-Handle-Black.png",
            "webCode": "h6"
          },
          {
            "text": "Lloyd D Handle - Stainless Steel",
            "sideImg": "",
            "mainImg": "Unity/Handles/D-Handle/D-Handle-Stainless_Steel.png",
            "webCode": "h7"
          }
        ]
      },
      {
        "text": "Knob Handle",
        "sideCode": "Swatches/Handles/Swatch-Knob-Handle.jpg",
        "mainImg": "",
        "fontAwesome": false,
        "childSubMenu": [
          {
            "text": "Lloyd Knob Handle - Brass",
            "sideImg": "",
            "mainImg": "Unity/Handles/Knob-Handle/Knob-Handle-Brass.png",
            "webCode": "h8"
          },
          {
            "text": "Lloyd Knob Handle - Black",
            "sideImg": "",
            "mainImg": "Unity/Handles/Knob-Handle/Knob-Handle-Black.png",
            "webCode": "h9"
          },
          {
            "text": "Lloyd Knob Handle - Stainless Steel",
            "sideImg": "",
            "mainImg": "Unity/Handles/Knob-Handle/Knob-Handle-Stainless_Steel.png",
            "webCode": "h10"
          }
        ]
      },
      {
        "text": "Handleless Rail",
        "sideCode": "Swatches/Handles/Swatch-Handleless-Rail.jpg",
        "mainImg": "",
        "fontAwesome": false,
        "childSubMenu": [
          {
            "text": "Handleless Rail - Brass",
            "sideImg": "",
            "mainImg": "Unity/Handles/Handleless-Rails/Handleless-Rail-Brass.png",
            "webCode": "h11"
          },
          {
            "text": "Handleless Rail - Anthracite",
            "sideImg": "",
            "mainImg": "Unity/Handles/Handleless-Rails/Handleless-Rail-Anthracite.png",
            "webCode": "h12"
          },
          {
            "text": "Handleless Rail - Champagne",
            "sideImg": "",
            "mainImg": "Unity/Handles/Handleless-Rails/Handleless-Rail-Champagne.png",
            "webCode": "h13"
          },
          {
            "text": "Handleless Rail - Copper",
            "sideImg": "",
            "mainImg": "Unity/Handles/Handleless-Rails/Handleless-Rail-Copper.png",
            "webCode": "h14"
          },
          {
            "text": "Handleless Rail - Aluminium",
            "sideImg": "",
            "mainImg": "Unity/Handles/Handleless-Rails/Handleless-Rail-Aluminium.png",
            "webCode": "h15"
          },
        ]
      },
      {
        "text": "Trim Handle",
        "sideCode": "Swatches/Handles/Swatch-Trim-Handle.jpg",
        "mainImg": "",
        "fontAwesome": false,
        "childSubMenu": [
          {
            "text": "Trim Handle - Brass",
            "sideImg": "",
            "mainImg": "Unity/Handles/Trim-Handle/Trim-Handle-Brass.png",
            "webCode": "h16"
          },
          {
            "text": "Trim Handle - Black",
            "sideImg": "",
            "mainImg": "Unity/Handles/Trim-Handle/Trim-Handle-Black.png",
            "webCode": "h17"
          },
          {
            "text": "Trim Handle - Stainless Steel",
            "sideImg": "",
            "mainImg": "Unity/Handles/Trim-Handle/Trim-Handle-Stainless_Steel.png",
            "webCode": "h18"
          }
        ]
      },
    ]
  },
  {
    "text": "Flooring Style",
    "textPosition": "side-menu",
    "imgCode": "Main_Icons/Flooring",
    "id": "block-5",
    "imgTxtOnly": false,
    "fontAwesome": false,
    "listType": "medium",
    "groupList": false,
    "subMenu": [
      {
        "text": "Chevron",
        "sideCode": "Swatches/Flooring/Swatch-Floor-Chevron.jpg",
        "mainImg": "Unity/Flooring/Floor-Chevron.png",
        "fontAwesome": false,
        "webCode": "f1"
      },
      {
        "text": "Plank",
        "sideCode": "Swatches/Flooring/Swatch-Floor-Plank.jpg",
        "mainImg": "Unity/Flooring/Floor-Plank.png",
        "fontAwesome": false,
        "webCode": "f2"
      },
      {
        "text": "Tiled",
        "sideCode": "Swatches/Flooring/Swatch-Floor-Tile.jpg",
        "mainImg": "Unity/Flooring/Floor-Tile.png",
        "fontAwesome": false,
        "webCode": "f3"
      },
    ]
  },
  {
    "text": "Wall Finish",
    "textPosition": "side-menu",
    "imgCode": "Main_Icons/Wall_Finish",
    "id": "block-6",
    "imgTxtOnly": false,
    "fontAwesome": false,
    "listType": "medium",
    "groupList": false,
    "subMenu": [
      {
        "text": "Exposed Brick",
        "sideCode": "Swatches/Wall-Finish/Swatch-Wall-Exposed_Brick.jpg",
        "mainImg": "Unity/Wall-Finish/Wall-Exposed_Brick.png",
        "fontAwesome": false,
        "webCode": "w1"
      },
      {
        "text": "Timber Slats",
        "sideCode": "Swatches/Wall-Finish/Swatch-Wall-Timber_Slats.jpg",
        "mainImg": "Unity/Wall-Finish/Wall-Timber_Slats.png",
        "fontAwesome": false,
        "webCode": "w2"
      },
      {
        "text": "Light Grey Painted Walls",
        "sideCode": "Swatches/Wall-Finish/Swatch-Wall-Light_Grey.jpg",
        "mainImg": "Unity/Wall-Finish/Wall-Light_Grey.png",
        "fontAwesome": false,
        "webCode": "w3"
      },
      {
        "text": "Mid Grey Painted Walls",
        "sideCode": "Swatches/Wall-Finish/Swatch-Wall-Mid_Grey.jpg",
        "mainImg": "Unity/Wall-Finish/Wall-Mid_Grey.png",
        "fontAwesome": false,
        "webCode": "w4"
      },
      {
        "text": "Dark Grey Painted Walls",
        "sideCode": "Swatches/Wall-Finish/Swatch-Wall-Dark_Grey.jpg",
        "mainImg": "Unity/Wall-Finish/Wall-Dark_Grey.png",
        "fontAwesome": false,
        "webCode": "w5"
      },
    ]
  },
  {
    "text": "Export",
    "textPosition": "side",
    "imgCode": "fas fa-file-export",
    "id": "block-7",
    "imgTxtOnly": false,
    "fontAwesome": true,
    "listType": "small",
    "groupList": false,
    "subMenu": [
      {
        "text": "Download Image",
        "sideCode": "far fa-image fa-lg fa-fw",
        "mainImg": "",
        "fontAwesome": true
      },
      //{
      //  "text": "Download PDF",
      //  "sideCode": "fas fa-file-pdf fa-lg fa-fw",
      //  "mainImg": "",
      //  "fontAwesome": true
      //}
    ]
  },
  {
    "text": "UNITY",
    "textPosition": "side",
    "imgCode": "",
    "id": "block-1",
    "imgTxtOnly": true,
    "fontAwesome": false,
    "listType": "",
    "groupList": false,
    "subMenu": [],
  },
];

export default data;